"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExploreIcon = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ExploreIcon = function ExploreIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.default, _extends({}, props, {
    viewBox: "0 0 25 24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "currentColor",
    d: "M23.7457 12C23.7457 18.2108 18.7108 23.2457 12.5 23.2457C6.28916 23.2457 1.25429 18.2108 1.25429 12C1.25429 5.78916 6.28916 0.754286 12.5 0.754286C18.7108 0.754286 23.7457 5.78916 23.7457 12Z",
    strokeWidth: "1.50857",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M23.3 12H21.5",
    strokeWidth: "1.65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M2.9002 12H1.7002",
    strokeWidth: "1.65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M12.5 2.4002V1.2002",
    strokeWidth: "1.65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M12.5 22.7996L12.5 21.5996",
    strokeWidth: "1.65",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    stroke: "currentColor",
    d: "M5.68084 18.3809C5.55118 18.6599 5.84017 18.9489 6.11917 18.8193L14.5847 14.8852C14.9379 14.7211 15.2216 14.4374 15.3857 14.0842L19.3197 5.61869C19.4494 5.33968 19.1604 5.05069 18.8814 5.18035L10.4159 9.11441C10.0627 9.27852 9.77901 9.56223 9.6149 9.91537L5.68084 18.3809ZM12.5003 10.5598C13.2988 10.5598 13.9403 11.2013 13.9403 11.9998C13.9403 12.7984 13.2988 13.4398 12.5003 13.4398C11.7017 13.4398 11.0603 12.7984 11.0603 11.9998C11.0603 11.2013 11.7017 10.5598 12.5003 10.5598Z"
  }));
};
exports.ExploreIcon = ExploreIcon;